import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NSSelectModule } from '@norfolk-southern/accessns-components';

import { DialogFooterModule } from '@ruby/shared/dialogs/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { AddShipmentsDialogComponent } from '@ruby/shared/dialogs/unit-train/add-shipments-dialog/components/add-shipments.dialog';
import { AddShipmentsContainer } from '@ruby/shared/dialogs/unit-train/add-shipments-dialog/containers/add-shipments.container';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';

@NgModule({
  declarations: [AddShipmentsContainer, AddShipmentsDialogComponent],
  imports: [
    CommonModule,
    DialogHeaderModule,
    DialogFooterModule,
    DirectivesModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    NSSelectModule,
    MatDatepickerModule
  ],
  exports: [AddShipmentsContainer]
})
export class AddShipmentsModule {}
